import styled from'@emotion/styled';
import { useEffect, useMemo, useState } from 'react';

import Progressbar from 'components/ui/ProgressBar';
import LastConfirmModal from "./LastComfirmModal";
import { usePostUploadFreeKit } from "hooks/api";
// import { sendingPhotoArrAtom }       from "components/pages/Onboarding/onboardingAtom";
import { sendingPhotoArrAtom } from 'components/pages/onboardingNew/newOnboardingAtom'
import { useAtom } from "jotai";


const Elem:React.FC<any> = ({ closeModal }) => {
  const { mutateAsync : postUploadFreeKit } = usePostUploadFreeKit();
  const [ sendingPhoto, setSendingPhoto ]  = useAtom(sendingPhotoArrAtom);
  const [ progress, setProgress ]          = useState(0);
  const [ showModal, setShowModal]         = useState(false);

  // photo/free 할때 id 값 보내줘야함
  const id = localStorage.getItem('name') || "";

  const uploadPhoto = useMemo(
    () => async () => {
      const formData = new FormData();
    sendingPhoto.forEach((file: any) => {
      formData.append('filename', file);
    });
    formData.append('orderType', '1');

    try {
      const response = await postUploadFreeKit({
        filename: formData,
        setProgress: setProgress,
        id
      });

      // 프로그래스 바 종료
      setProgress(100);
      setShowModal(true); // 업로드 완료 시 최종 모달 표시
    } catch (error) {
      console.error('Upload error:', error);
    }
  }, [sendingPhoto, postUploadFreeKit])

  // const uploadPhoto = useMemo(
  //   () => async () => {
  //     console.log('sendingPhoto2', sendingPhoto);
  //     const formData = new FormData();
  //   sendingPhoto.forEach((file: any) => {
  //     formData.append('filename', file);
  //   });
  //   formData.append('orderType', '1');

  //   try {
  //     console.log('sendingPhoto3', sendingPhoto);
  //     const response = await postUploadFreeKit({
  //       filename: formData,
  //       setProgress: setProgress,
  //       id
  //     });
  //     console.log(response)
  //     // 프로그래스 바 종료
  //     setProgress(100);
  //     setShowModal(true); // 업로드 완료 시 최종 모달 표시
  //   } catch (error) {
  //     console.error('Upload error:', error);
  //   }
  // }, [sendingPhoto, postUploadFreeKit])

  useEffect(() => {
    console.log('sendingPhoto1',sendingPhoto)
    if (progress === 0) {
      uploadPhoto();
       // 프로그래스가 0일때 사진 업로드 시작
      console.log('start')
    }

    let interval:NodeJS.Timeout | null = null;;
    
    if (progress < 100) {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress === 100) {
            clearInterval(interval as NodeJS.Timeout); // 프로그래스 바가 100이 되면 interval 중지
          }
          return prevProgress;
        });
      }, 1000);
    };

    return () =>{
      if (interval) {
        clearInterval(interval as NodeJS.Timeout); // 컴포넌트 언마운트 시 interval 중지
      }
    } 
  }, [sendingPhoto, postUploadFreeKit, progress]);

  return(
    <>
    <Background>
      <ModalContainer>
        <ContextContainer>
          <Title>전송 중입니다...</Title>
          <ProgressBarContainer>
            <PercentageWrpper>
              {progress} %
            </PercentageWrpper>
            <ProgressBarWrapper>
              <Progressbar progress={progress} />
            </ProgressBarWrapper>
          </ProgressBarContainer>
            <ButtonContainer>
            <ButtonWrapper>
              <SelectButton >
                다시 선택
              </SelectButton>
            </ButtonWrapper>
            <ButtonWrapper>
              <SelectButton>
                확정 후 전송
              </SelectButton>
            </ButtonWrapper>
          </ButtonContainer>
        </ContextContainer>
      </ModalContainer>
    </Background>
    {showModal && <LastConfirmModal />}
    </>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.50);
  z-index: 0;
`
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 80%;
  max-width: 343px;
  width: 100%;
  height: 231px;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;

  border-radius: 10px;
  
  @media (max-width: 321px) {
    padding: 0 10px 0;
  }
`;
const ContextContainer = styled.div`
  max-width: 299px;
  width: 100%;
  height: 172px;
  margin: 36px auto 0 ;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  line-height: 133%;
  margin: 0 auto;

  color: #000000;
`;
const ProgressBarContainer = styled.div`
  width: 100%;
  height: 55px;
  margin-top: 13px;
  display: flex;
  flex-direction: column;
`
const PercentageWrpper = styled.div`
  width: 50px;
  height: 13px;
  margin: 0 auto;
`
const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 5px;
  margin-top: 38px;
`
const ButtonContainer = styled.div`
  max-width: 295.01px;
  width: 100%;
  height: 47px;
  margin: 33px auto 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonWrapper = styled.div`
  height: 100%;
  max-width: 140.06px;
  width: 48%;
`

const SelectButton = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #DBC6A7;
  color: white;
`;